import { Component } from 'react'

import { RouteComponentProps } from 'react-router'

import { sendAcceptEvent } from './events'

import TosService from 'modules/tos/service'

type PathParamsType = {
  hash: string
}

export interface IProps extends RouteComponentProps<PathParamsType> {
  isAccepted: boolean
}

export interface IState {
  title?: string,
  text?: string,
  buttonText?: string,
  version?: string,
  valid: boolean
}

export default class Controller {
  view: Component<IProps, IState>

  constructor(view: Component<IProps, IState>) {
    this.view = view
    this.view.state = {
      valid: true
    }
  }

  loadTos = () => {
    TosService.getLast().then(response => {
      this.view.setState({
        title: response?.tosJson.title,
        text: response?.tosJson.text,
        buttonText: response?.tosJson.buttonText,
        version: response.version
      })
      this.checkValidity()
    }).catch(error => {
      console.error(error)
    })
  }

  onAccept = () => {
    sendAcceptEvent()

    const tosInfo = {
      version: this.view.state.version,
      transmission: this.view.props.match.params.hash
    }

    if (this.view.state.version) {
      localStorage.setItem('tos', JSON.stringify(tosInfo))
    }
    this.checkValidity()
  }

  checkValidity = () => {
    const hash = this.view.props.match.params.hash
    const storedTosInfo = localStorage.getItem('tos')
    const tosInfo = storedTosInfo ? JSON.parse(storedTosInfo) : void 0
    const versionMatch = tosInfo ? tosInfo.version === this.view.state.version : false
    const transmissionMatch = tosInfo ? tosInfo.transmission === hash : false

    this.view.setState({
      valid: versionMatch && transmissionMatch
    })
  }
}
